import { ItineraryVersionPauseInterval } from 'core/graphql/types';
import ItineraryPauseInterval from '../itineraryPauseInterval/ItineraryPauseInterval';

export interface PauseIntervalsProps {
  pauseIntervals: ItineraryVersionPauseInterval[];
}

const PauseIntervals = ({ pauseIntervals }: PauseIntervalsProps) => (
  <>
    <div className="mt-2">
      <span>Pause Intervals</span>
      <span className="ml-2 rounded-lg bg-gray px-2 dark:bg-design-secondary-black">
        {pauseIntervals.length ?? 0}
      </span>
    </div>
    <div className="mr-1">
      {pauseIntervals.map((pi) => (
        <ItineraryPauseInterval key={pi.id} item={pi} />
      ))}
    </div>
  </>
);

export default PauseIntervals;
